import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
 
  {
    // 前端页面
    path: "/operate",
    name: "operate",
    component: () => import("@/views/operate/Layout.vue"),
    children: [
      {
        path: "index",
        name: "index",
        component: () => import("@/views/operate/Index.vue"),
      },
      {
        path: "course",
        name: "course",
        component: () => import("@/views/operate/course/Index.vue"),
      },
      {
        path: "courseContent",
        name: "courseContent",
        component: () => import("@/views/operate/course/CourseContent.vue"),
      },
      {
        path: "userCenter",
        component: () => import("@/views/operate/userCenter/Index.vue"),
      },
      {
        path: "growthRecord",
        name: "growthRecord",
        component: () => import("@/views/operate/growthRecord/Index.vue"),
      },
      {
        path: "certification",
        name: "certification",
        component: () => import("@/views/operate/certification/Index.vue"),
      },
      {
        path: "authenticationCourseContent",
        name: "authenticationCourseContent",
        component: () => import("@/views/operate/course/CourseContent.vue"),
      },
      {
        path: "query",
        name: "query",
        component: () => import("@/views/operate/certification/Query.vue"),
      },
      {
        path: "faq",
        component: () => import("@/views/operate/FAQ.vue"),
      },
      {
        path: "exam",
        name: "exam",
        component: () => import("@/views/operate/exam/Index.vue"),
      },
      {
        path: "examResult",
        name: "examResult",
        component: () => import("@/views/operate/exam/Result.vue"),
      },
      {
        path: "examLogs",
        name: "examLogs",
        component: () => import("@/views/operate/exam/Logs.vue"),
      },
      {
        path: "agentCenter",
        name: "agentCenter",
        component: () => import("@/views/operate/agentCenter/Index.vue"),
      },
      {
        path: "loginBefore",
        name: "loginBefore",
        component: () => import("@/views/operate/LoginBefore.vue"),
      },
      {
        path: "live",
        name: "live",
        component: () => import("@/views/operate/live/Index.vue"),
      },
      {
        path: "agentEmpowerment",
        name: "agentEmpowerment",
        component: () => import("@/views/operate/course/AgentEmpowerment.vue"),
      },{
        path: "agencySummaryData",
        name: "agencySummaryData",
        component: () => import("@/views/operate/agentCenter/AgencySummaryData.vue"),
      },{
        path: "bigSeaAgent/:agent",
        name: "bigSeaAgent",
        component: () => import("@/views/operate/agentCenter/BigSeaAgent.vue"),
      },
      // {
      //   path: "agentSEAEmpowerment",
      //   name: "agentSEAEmpowerment",
      //   component: () =>
      //     import("@/views/operate/course/AgentSEAEmpowerment.vue"),
      // },
      {
        path: "login",
        name: "login",
        component: () => import("@/views/operate/login/Index.vue"),
      }
    ],
  },
  {
    // H5页面
    path: "/mobile",
    name: "mobile",
    component: () => import("@/views/mobile/Layout.vue"),
    children: [
      {
        path: "index",
        component: () => import("@/views/mobile/Index.vue"),
      },
      {
        path: "authentication",
        name: "mobileCertification",
        component: () => import("@/views/mobile/Authentication.vue"),
      },
      {
        path: "mine",
        component: () => import("@/views/mobile/Mine.vue"),
      },
      {
        path: "message",
        component: () => import("@/views/mobile/Message.vue"),
      },
      {
        // 课程中心
        path: "course",
        name: "mobileCourse",
        component: () => import("@/views/mobile/course/Index.vue"),
      },
      {
        // 课程详情
        path: "courseContent",
        name: "mobileCourseContent",
        component: () => import("@/views/mobile/course/CourseContent.vue"),
      },
      {
        // 认证课程详情
        path: "authenticationCourseContent",
        name: "mobileAuthenticationCourseContent",
        component: () => import("@/views/mobile/course/CourseContent.vue"),
      },
      // {
      //   path: "userCenter",
      //   component: () => import("@/views/operate/userCenter/Index.vue"),
      // },
      // {
      //   path: "growthRecord",
      //   name: "growthRecord",
      //   component: () => import("@/views/operate/growthRecord/Index.vue"),
      // },
      // {
      //   path: "certification",
      //   name: "certification",
      //   component: () => import("@/views/operate/certification/Index.vue"),
      // },
      // {
      //   path: "authenticationCourseContent",
      //   component: () => import("@/views/operate/course/CourseContent.vue"),
      // },
      {
        // 证书查询结果
        path: "query",
        name: "mobileQuery",
        component: () => import("@/views/mobile/certification/Query.vue"),
      },
      {
        path: "faq",
        component: () => import("@/views/mobile/FAQ.vue"),
      },
      {
        path: "exam",
        name: "examMobile",
        component: () => import("@/views/mobile/exam/Index.vue"),
      },
      {
        path: "examResult",
        name: "examResultMobile",
        component: () => import("@/views/mobile/exam/Result.vue"),
      },
      {
        path: "examLogs",
        name: "examLogsMobile",
        component: () => import("@/views/mobile/exam/Logs.vue"),
      },
      {
        path: "examDefault",
        name: "examDefaultMobile",
        component: () => import("@/views/mobile/exam/Default.vue"),
      },
      {
        path: "agentCenter",
        name: "agentCenterMobile",
        component: () => import("@/views/mobile/agentCenter/Index.vue"),
      },
      {
        path: "loginBefore",
        name: "mobileLoginBefore",
        component: () => import("@/views/mobile/LoginBefore.vue"),
      },
      {
        path: "live",
        name: "mobileLive",
        component: () => import("@/views/mobile/live/Index.vue"),
      },
      {
        path: "courseCalendar",
        name: "mobileCourseCalendar",
        component: () => import("@/views/mobile/courseCalendar/Index.vue"),
      },
      {
        path: "agentEmpowerment",
        name: "mobileAgentEmpowerment",
        component: () => import("@/views/mobile/course/AgentEmpowerment.vue"),
      },
      // {
      //   path: "agentSEAEmpowerment",
      //   name: "mobileAgentSEAEmpowerment",
      //   component: () =>
      //     import("@/views/mobile/course/AgentSEAEmpowerment.vue"),
      // },


      // 志成添加
       {
        // 课程打卡页面
        path: "courseClockIn",
        name: "mobileCourseClockIn",
        component: () => import("@/views/mobile/course/CourseClockIn.vue"),
      },


    ],
  },
  {
    // H5页面
    path: "/mobile",
    name: "mobile2",
    children: [
      {
        path: "agentReport/:quarter/:agent",
        name: "mobileagentReport",
        component: () => import("@/views/agentReport/Index.vue"),
      },
      {
        path: "agentReportYear/:quarter/:agent",
        name: "mobileagentReportYear",
        component: () => import("@/views/agentReportYear/Index.vue"),
      },
      {
        path: "agentReportSEA/:quarter/:agent",
        name: "mobileagentReportSEA",
        component: () => import("@/views/agentReportSEA/Index.vue"),
      },
      {
        path: "agentReportppe/:quarter/:agent",
        name: "mobileagentReportppe",
        component: () => import("@/views/agentReportppe/Index.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/operate/Auth.vue"),
    meta: { title: "权限验证" },
  },
  {
    path: "/empower",
    name: "empower",
    component: () => import("@/views/operate/Empower.vue"),
    meta: { title: "权限验证" },
  },
  {
    path: "/404",
    name: "exception404",
    component: () => import("@/views/basic/404.vue"),
    meta: { title: "404" },
  },
  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: () => import("@/views/operate/Callback.vue"),
  },
  {
    path: "/405",
    name: "exception405",
    component: () => import("@/views/basic/405.vue"),
    meta: { title: "405" },
  },
  {
    path: "/403",
    name: "exception403",
    component: () => import("@/views/basic/403.vue"),
    meta: { title: "403" },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/operate/index",
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});
// console.log("route", process.env.BASE_URL);
export default router;
